<dynamic-form
  *ngIf="formGroup !== undefined && isOkForLoad"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [isShowModal]="false"
  [erroremessage]="erroremessage"
  [hasDefault]="false"
  (valueChangeByApiName)="onValueChangeByApiName($event)"
  (valueChange)="onHeaderValueChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-tabset (tabChange)="selectTab($event)">
      <ssg-tab class="document" tabTitle="سند" [active]="isActveTab('سند')">
        <ng-container class="detail" *ngIf="currentVoucherKind && TrsVoucherDetailsColumns && TrsVoucherDetailsColumns.length > 0">
          <trs-voucher-detail
            #detail
            (valueChanges)="onValueChanges($event)"
            [hasReferenceRequired]="hasReferenceRequired"
            [isAdd]="!isNoValidForEdit()"
            [isEdit]="!isNoValidForEdit()"
            [isDelete]="!isNoValidForEdit()"
            [hasReference]="hasReference"
            [filterEntity]="filterEntity"
            [headerTitleToDetailTitle]="headerTitleToDetailTitle"
            [ReferenceVoucherKindId]="ReferenceVoucherKindId"
            [CurrentVoucherKind]="currentVoucherKind"
            [columns]="TrsVoucherDetailsColumns"
            [RowNumberName]="'RowNumber'"
            [(dataList)]="model.TrsVoucherDetails">
          </trs-voucher-detail>
        </ng-container>
      </ssg-tab>
      <ssg-tab class="related-document" tabTitle="اسناد مرتبط" [active]="currentSettlementConcern?.InvVoucherKindId && isActveTab('اسناد مرتبط')">
        <kgrid
          *ngIf="TrsSettlementVoucherColumns && TrsSettlementVoucherColumns.length > 0"
          #grid
          [apiName]="apiName"
          [areaName]="areaName"
          [label]="label"
          [noToolBar]="true"
          [groupable]="false"
          [isAdd]="false"
          [isEdit]="false"
          [isDelete]="false"
          [isMulti]="true"
          [name]="apiName"
          dataKey="'UId'"
          [mySelection]="SelectedSettlement"
          (onRowsSelected)="RowCheckStateChanged($event)"
          [columns]="TrsSettlementVoucherColumns"
          [paging]="false"
          (onRefreshData)="SetInvSellVoucher()"
          [dataList]="grdSettlementVoucher"
          reportName="TrsSettlementVouchers"
          pathPreFix="TRS">
          <ng-container class="toolbar">
            <ssg-input class="mr-auto" name="TrsVoucherTotal" [group]="formGroup" [withComma]="true" [textType]="'number'" label="جمع رسید">
            </ssg-input>
          </ng-container>
        </kgrid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
  <ng-container class="footer">
    <ssg-button class="btnstyle" (click)="ngOnInit()" data-tooltip="top" tooltip="بازخوانی اطلاعات" icon="icon-refresh-o"> </ssg-button>
    <ssg-button
      icon="icon-list-f"
      buttontype="button"
      (click)="loadVoucherList()"
      class="login-btn"
      tooltip="لیست اسناد"
      [disabled]="false"
      class="btnstyle">
    </ssg-button>
    <ssg-button
      icon="icon-file-document-multiple-outline"
      buttontype="button"
      (click)="newVoucher()"
      class="btnstyle"
      tooltip="سند جدید"
      [disabled]="isNewRow">
    </ssg-button>
    <ssg-button
      icon="icon-auto_delete-o"
      buttontype="button"
      (click)="deleteVoucher()"
      class="btnstyle"
      tooltip="حذف سند دریافت و پرداخت"
      [disabled]="model?.StatusKindCode >= 2 || isNewRow">
    </ssg-button>
    <ssg-button
      icon="icon-content_copy-o"
      buttontype="button"
      (click)="voucherRefrenceTo()"
      class="btnstyle"
      tooltip="سند معطوف"
      [disabled]="model?.StatusKindCode != 2 || isNoValidForEdit()">
    </ssg-button>
    <ng-container *ngIf="!HasJournalVoucher">
      <ssg-button
        *hasPermission="['Treasury:TrsVoucherHeader/CreateAccVoucher', 'Same']"
        icon="icon-create_new_folder-o"
        (click)="accountAccVoucher(true)"
        buttontype="button"
        class="btnstyle"
        tooltip="صدور سند حسابداری"
        [disabled]="!HasJournalVoucher || isNewRow || model.AccVoucherHeaderId">
      </ssg-button>
      <ssg-button
        *hasPermission="['Treasury:TrsVoucherHeader/DeleteAccVoucher', 'Same']"
        icon="icon-delete-sweep-outline"
        (click)="accountAccVoucher(false)"
        buttontype="button"
        class="btnstyle"
        tooltip="حذف سند حسابداری"
        [disabled]="!HasJournalVoucher || isNewRow || !model.AccVoucherHeaderId">
      </ssg-button>
      <ssg-button
        *hasPermission="['Treasury:TrsVoucherHeader/ViewAccVoucher', 'Same']"
        icon="icon-table_view-f"
        (click)="viewAccVoucher()"
        buttontype="button"
        class="btnstyle"
        tooltip="نمایش سند حسابداری"
        [hidden]="!HasJournalVoucher"
        [disabled]="!HasJournalVoucher || !model.AccVoucherHeaderId">
      </ssg-button>
    </ng-container>
    <ssg-button
      icon="icon-folder-open-outline"
      buttontype="button"
      (click)="voucherConfirm()"
      class="btnstyle"
      [tooltip]="confirmLabel"
      [disabled]="model?.StatusKindCode > 2 || isNewRow">
    </ssg-button>
    <ssg-button
      *ngIf="currentVoucherKind?.IsCheckBook && currentVoucherKind?.HasCheckPrint"
      icon="icon-print-checked"
      (click)="chequeBookPrint('Print')"
      buttontype="button"
      class="btnstyle"
      tooltip="چاپ چک"
      [disabled]="hasChequeBookPrint() || isNewRow">
    </ssg-button>
    <ssg-button
      *ngIf="currentVoucherKind?.IsCheckBook && currentVoucherKind?.HasCheckPrint"
      icon="icon-print-checked"
      (click)="chequeBookPrint('Edit')"
      buttontype="button"
      class="btnstyle"
      tooltip="طراحی قالب چک"
      [disabled]="hasChequeBookPrint() || isNewRow">
    </ssg-button>
    <ssg-menu *ngIf="!isNewRow" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </ng-container>
</dynamic-form>
